// extracted by mini-css-extract-plugin
module.exports = {"error":"uw7e_Pix","limit":"ouoinw5K","pre":"UVf8ychc","loading":"CSMmIiMh","icon":"qqvFIsug","circleAnimation":"lcrqiCSO","text":"NfWCrDQg"};